module.exports = __webpack_public_path__ + "img/photo-56.889ebb02.jpg";